import { render, staticRenderFns } from "./versionDetail.vue?vue&type=template&id=2e764b1c&scoped=true"
import script from "./versionDetail.vue?vue&type=script&lang=js"
export * from "./versionDetail.vue?vue&type=script&lang=js"
import style0 from "./versionDetail.vue?vue&type=style&index=0&id=2e764b1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e764b1c",
  null
  
)

export default component.exports